import { addRoamingItem, deleteRoamingItem, getGarmentItemsClientView, getGarmentItemsView } from 'api/roamingItems.api';
import { useEffect, useState } from 'react';
import './RoamingItemsClientList.css';
import RoamingItemsTable from '../../RoamingItemsTable/RoamingItemsTable';
import { GarmentItem, Ipagination } from 'domain/RoamingItems';
import RoamingItemsClientTable from './RoamingItemsClientTable/RoamingItemsClientTable';

const RoamingItemsClientList = () => {
  const [dataSource, setDataSource] = useState<GarmentItem[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [pagination, setPagination] = useState<Ipagination>({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [filters, setFilters] = useState({});

  const loadGarmentItemsClientView = () => {
    setIsLoading(true);

    const { current, pageSize } = pagination;
    const skip = (current - 1) * pageSize;

    let filterStr = "";
    if (filters && Object.keys(filters).length > 0) {
      filterStr = Object.entries(filters)
        .map(([key, value]) => {
          if (!isNaN(Number(value))) {
            return `${key} eq ${Number(value)}`;
          }
          return `contains(${key}, '${String(value).replace(/'/g, "''")}')`;
        })
        .join(" and ");
    }
    getGarmentItemsClientView({ top: pageSize, skip, filter: filterStr })
      .then((data) => {
        const { value, "@odata.count": totalCount } = data;
        setPagination((prev: any) => ({
          ...prev,
          total: totalCount || 0,
        }));
        setDataSource(value || []);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    loadGarmentItemsClientView();
  }, [pagination.current, pagination.pageSize, filters]);
    
  return (
    <>
      <RoamingItemsClientTable
        loading={isLoading}
        pagination={pagination}
        setPagination={setPagination}
        setFilters={setFilters}
        data={dataSource}
        onAddItem={(row: any) => {
          const { GarmentId, Price, SellPrice } = row
          addRoamingItem({ garment_id: GarmentId, price: Price, sell_price: SellPrice })
          // deleteRoamingItem(13)
        }}
      />

      {/* <Footer className="sticky-footer">
        <Button
          loading={isLoading}
          // htmlType="submit"
          type={"primary"}
          icon={<PlusIcon />}
        >
          Add New Leasing Plan
        </Button>
      </Footer> */}
    </>
  );
};

export default RoamingItemsClientList;